// extracted by mini-css-extract-plugin
module.exports = {"container":"Testimonials_container__50KnT","list":"Testimonials_list__id2la","noDesktopPadding":"Testimonials_noDesktopPadding__A1kaD"};